import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';
import { serverRequest } from "../../../util/server_request";
import { extractErrorMessage } from '../../extractErrorMessage';
import { notifyUser } from '../../../util/util';

const notifiedErrors = new Set();

const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

export function usePensionContributions(memberNumber = null, enabled = false) {
  return useQuery({
    queryKey: ['pension-contributions', memberNumber],
    queryFn: async () => {
      try {
        const result = await serverRequest('GET', `contributions/summary`);
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch pension contributions');
        }
        
        const raw = result.data || {};
        
        return {
          success: result.success,
          message: result.message,
          summary: {
            totalContributions: raw.total_contributions || 0,
            totalRedemption: raw.total_redemption || 0,
            accruedInterest: raw.gain_loss || 0,
            accountValue: raw.main_current_value || raw.current_value || 0,
            employerContribution: Math.abs(raw.total_employer_contributions || 0),
            transferReceived: 0,
            unitsBroughtForward: 0,
            currentPrice: raw.current_unit_price || 0,
            dateJoined: raw.last_contribution_date || '',
          },
          transactions: [],
          pagination: {},
        };
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch pension contributions');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: enabled && !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
